import React, { Component } from 'react'
import accounting from 'accounting'
import classnames from 'classnames'

class Box extends Component {
  onClick = (event) => {
    event.preventDefault()
    this.props.onBuy(this.props.item)
  }

  render () {

    return (
      <div className="ss-box-inner">
        <div className="title">{this.props.item.title}</div>
        <hr/>
        <div className="price">Rp {accounting.formatMoney(this.props.item.price, '', '0')}</div>
        <hr/>
        <div className="desc">
          Get cozy with our new pillow!
          <br/>
          <br/>
          <i>
            Disclaimer : This is a test transaction, no funds will move from your account.
            <br/>
            Please buy a good pillow - your neck will thank you.
          </i>
        </div>
        <a className="btn buy" href="#" onClick={this.onClick}>
          BUY NOW
        </a>
        <div className={classnames('midtrans-signup')}>
          <div className="desc-cta">Ready to integrate to Midtrans?</div>
          <a href="https://dashboard.midtrans.com/register" target="_blank" className="btn btn-signup">
            SIGN UP
          </a>
        </div>
        <div className="midtrans-signup-popup-open">
        </div>
      </div>
    )
  }
}

export default Box
